import {IllustrationMessageComponent} from './illustration-message.component';
import {contextColors} from '../../@theme/theme-colors';

export const NO_DATA_MESSAGE_DEFAULTS: Partial<IllustrationMessageComponent> = {
    size: 'md',
    iconName: 'folder-open',
    circleColor: [contextColors['brand-3'], .4],
    title: 'No data to show',
};
